// extracted by mini-css-extract-plugin
export default {"list":"Team_list__uW9rq"};